export default "__VITE_ASSET__oPNZEDW9__"